import { Button, Text, theme } from "@pallet-hq/hegel"
import { useRouter } from "next/router"
import config from "config"
import { FullPageDiv, InfoDiv } from "./shared/styles"
import styled from "@emotion/styled"

const GenericError = () => {
    const router = useRouter()

    return (
        <FullPageDiv style={{ height: "100vh" }}>
            <InfoDiv>
                <Text variant="headlineMedium" mb="medium">
                    Something went wrong!
                </Text>
                <Text variant="paragraphMedium" color="gray600" mb="medium">
                    The Pallet team has been notified of this issue and will
                    resolve it soon!
                </Text>
                <Text variant="paragraphMedium" color="gray600" mb="medium">
                    If you wish to provide some additional details around this
                    issue, please contact the team{" "}
                    <Link href={`mailto:${config.SUPPORT_EMAIL}`}>
                        {config.SUPPORT_EMAIL}
                    </Link>
                </Text>
                <Button size="small" width={1} onClick={router.back}>
                    Go back
                </Button>
            </InfoDiv>
        </FullPageDiv>
    )
}

export default GenericError

const Link = styled.a`
    color: ${theme.colors.blue};
    text-decoration: none;
`
